import { render, staticRenderFns } from "./WorkflowManagementRoles.vue?vue&type=template&id=855c2f14&scoped=true"
import script from "./WorkflowManagementRoles.vue?vue&type=script&lang=js"
export * from "./WorkflowManagementRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855c2f14",
  null
  
)

export default component.exports